import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Audit, AuditListParams } from '~core/models/auditor.models';
import { ApiConstantsService } from './api-constants.service';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class AuditService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    params?: AuditListParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<Audit>> {
    return this._http.get<Pagination<Audit>>(
      this._apiConstantsService.auditUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(auditId: string, params?: AuditListParams): Observable<Audit> {
    return this._http.get<Audit>(
      `${this._apiConstantsService.auditUrl}/${auditId}`,
      { params }
    );
  }
}
